import { useState, useEffect } from "react"
import { Link } from "react-router-dom"

import "./index.scss"
import AnimatedLetters from "../AnimatedLetters"
import AnimatedLogos from "../AnimatedLogos"
import LogoTitle from "../../assets/images/logo-g-s.png"
import logoData from "../../utils/logoData"
import usePageMeta from "../../utils/usePageMeta"

const Home = () => {
    const [letterClass, setLetterClass] = useState("text-animate")
    const [logoClass, setLogoClass] = useState("logo-animate")
    const nameArray = ["r", "e", "g"]
    const jobArray1 = ['f', 'u', 'l', 'l', '-', 's', 't', 'a', 'c', 'k', ' ', '&']
    const jobArray2 = ['A', 'I', ' ', 'e', 'n', 'g', 'i', 'n', 'e', 'e', 'r', '.']

    usePageMeta({
        title: "Greg Chui – Full-stack & AI Engineer",
        description: "Greg Chui is a full-stack and AI engineer building production web apps with React, Next.js, Node.js, Python and LLM-powered features.",
        path: "/",
    })

    useEffect(() => {
        setTimeout(() => {
            setLetterClass("text-animate-hover")
            setLogoClass("logo-animate-hover")
        }, 1800);
    })

    return (
        <>
            <div className="home-scrim" aria-hidden="true" />
            <div className="container home-page">
                <div className="text-zone">
                    <h1>
                        <span className="sr-only">Hi, I'm Greg, full-stack &amp; AI engineer.</span>
                        <span aria-hidden="true">
                            <span className={letterClass}>H</span>
                            <span className={`${letterClass} _12`}>i,</span>
                            <br />
                            <span className={`${letterClass} _13`}>I</span>
                            <span className={`${letterClass} _14`}>'m</span>
                            <span className="word">
                                <img src={LogoTitle} alt="" />
                                <AnimatedLetters
                                    letterClass={letterClass}
                                    strArray={nameArray}
                                    idx={15}
                                />
                            </span>
                            <br />
                            <AnimatedLetters
                                letterClass={letterClass}
                                strArray={jobArray1}
                                idx={18}
                            />
                            <br />
                            <AnimatedLetters
                                letterClass={letterClass}
                                strArray={jobArray2}
                                idx={30}
                            />
                        </span>
                    </h1>
                    <h2>I build production web apps end to end — React & Next.js front ends, Node & Python APIs, databases, and LLM-powered features.</h2>
                    <div className="home-actions">
                        <Link to="/portfolio" className="flat-button">PORTFOLIO</Link>
                        <Link to="/contact" className="flat-button contact-button">CONTACT ME</Link>
                    </div>
                </div>
                <div className="tech-logo-cont">
                    <AnimatedLogos
                        logoClass={logoClass}
                        logoArray={logoData}
                        idx={30}
                    />
                </div>
            </div>
        </>
    )
}

export default Home